
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { withdrawInfo, coinTransfer, getUserMoney } from '../service/getdata'
export default {
data(){
return{
show:false,
msg:"",
address: "",
userMoney: [],
showAlert: false,
fromnumber: "",
resultnumber: "",
actions: [{ name: 'USDT' }, { name: 'BTC' }, { name: 'ETH' }],  //选择提币的币种列表
type: "",
coin1: "USDT", //选中提的币种
coin2: "ETH",
showSymbol: false, //底部选择币种弹出框的展示隐藏
coinListInfo: {},
unit: "eur"
}
},
components:{
XHeader,
Toast
},
created(){
this.SETTOKEN()
this.unit = window.localStorage.getItem('unit') || 'eur'
clearInterval(this.timerInfo)
this.timerInfo = null
this.getPrice(true)
this.getData()
this.timerInfo = setInterval(() => {
this.getPrice()
}, 2000);

},
computed:{
...mapState([ 'token'])
},
methods:{
...mapMutations(['SETTOKEN']),
getPrice(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}

getUserMoney({token: this.token, symbol: this.unit}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userMoney = res.data.change_wallet
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
getData(){
var that = this
this.$Loading()
withdrawInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1' || res.status=='0'){
that.coinListInfo = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
change(){
const coina = this.coin1
const coinb = this.coin2
this.coin1 = coinb
this.coin2 = coina
},
changeCoin(){
if(this.coin1=='USDT' && this.coin2=='BTC'){
this.resultnumber = Number(this.fromnumber)/Number(this.userMoney[0].price)
}
if(this.coin1=='USDT' && this.coin2=='ETH'){
this.resultnumber = Number(this.fromnumber)/Number(this.userMoney[1].price)
}
if(this.coin1=='ETH' && this.coin2=='USDT'){
this.resultnumber = Number(this.userMoney[1].price)*Number(this.fromnumber)
}
if(this.coin1=='BTC' && this.coin2=='USDT'){
this.resultnumber = Number(this.userMoney[0].price)*Number(this.fromnumber)
}

if(this.coin1=='BTC' && this.coin2=='ETH'){
this.resultnumber = Number(this.userMoney[0].price)/Number(this.userMoney[1].price)*Number(this.fromnumber)
}

if(this.coin1=='ETH' && this.coin2=='BTC'){
this.resultnumber = Number(this.userMoney[1].price)/Number(this.userMoney[0].price)*Number(this.fromnumber)
}

},
clearTimer() { //清楚定时器

clearInterval(this.timerInfo)
this.timerInfo = null
},
save(){
if(this.fromnumber==''){
this.sendMsg(this.$t("请输入转换数量"))
return
}
this.showAlert = false

var that = this
this.$Loading()
coinTransfer({token: this.token, from: this.coin1, to: this.coin2, uid: window.localStorage.getItem("uid"), fromnumber: this.fromnumber}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getData()


}
})
}else if(res.status=='-1'){

}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
showModal(){
if(this.fromnumber==''){
this.sendMsg(this.$t("请输入转换数量"))
return
}
this.showAlert = true

},
onSelect(item) {
this.showSymbol = false;
if(this.type==1){
this.coin1 = item.name;
}else{
this.coin2 = item.name;
}
},
onClose(){

},
share(val) {
if (!val) {
return
}
navigator.clipboard.writeText(val).then(() => {
this.sendMsg(this.$t('复制成功'));
})
},
async pastCont() {
this.address = await navigator.clipboard.readText();
},

sendMsg(content) {
this.msg = content;
this.show = true;
}
},
watch: {

fromnumber: {
handler(curVal, oldVal) {
this.changeCoin()
},
deep: true
},
coin2: {
handler(curVal, oldVal) {
this.changeCoin()
},
deep: true
},
coin1: {
handler(curVal, oldVal) {
this.changeCoin()
},
deep: true
}
},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
}



// WEBPACK FOOTER //
// ./src/pages/exchange.vue